type Filters = {
    [id: string]:
        | string
        | number
        | string[]
        | number[]
        | {
              day?: number | null;
              month?: number | null;
              year?: number | null;
          }
        | null;
};

export const serializeFilters = (filters: Filters) => {
    return Object.entries(filters)
        .filter(([_, value]) => value !== null && value !== "")
        .map(([key, value]) => {
            if (Array.isArray(value)) {
                if (value.length === 0) return null;
                return { [key]: value.join(",") };
            }

            if (typeof value === "object" && value !== null) {
                const { day, month, year } = value;
                const dateParts: string[] = [];

                if (day !== null && day !== undefined) {
                    dateParts.push(`day:${day}`);
                }
                if (month !== null && month !== undefined) {
                    dateParts.push(`month:${month}`);
                }
                if (year !== null && year !== undefined) {
                    dateParts.push(`year:${year}`);
                }

                if (dateParts.length > 0) {
                    return { [key]: dateParts.join(",") };
                }

                return null;
            }

            return { [key]: value };
        })
        .filter(
            (value): value is { [key: string]: string | number } =>
                value !== null
        )
        .reduce((acc, curr) => Object.assign(acc, curr), {});
};
